import React from 'react';
import H2Homepage from "./H2homepage";
import Riboahp from "./Riboahp";
import iconwaitinglist from "../../style/icons/clockblack.svg";


const WaitingHpContainer = () => {
    return (
        <div className={'notif-container'}>
            <H2Homepage title={'רשימת המתנה'} iconName={iconwaitinglist}/>
            <div className={'riboa-main'}>
                <Riboahp/>
                <Riboahp/>

                <Riboahp/>
                <Riboahp/>
                <Riboahp/>

            </div>
        </div>
    );
};

export default WaitingHpContainer;